import { React, useState, useEffect, Suspense } from "react";
import { useNavigate, useParams } from "react-router-dom";

// import Container from "react-bootstrap/Container";
// import Col from "react-bootstrap/Col";
// import Row from "react-bootstrap/Row";

import { Col, Row, Container, Modal, Button, Spinner } from "react-bootstrap";

import "./ClassOverview.css";
import "./JiSiReportsOverview.css";

import GradeCard from "./GradeCard";
import ReturnToResults from "./ReturnToResults";
import PrintJiSiReports from "./PrintJiSiReports";
import HandoverClassTable from "./HandoverClassTable";
import ExpandedHandoverView from "./ExpandedHandoverView";

import { getResultsByStudent, getReportOptions, getJiSiReportByStudentId, upsertJiSiReport } from "../services/APIClient";

function JiSiReportsOverview(props) {
  console.log(props);

  let classDetails = props.classDetails;
  let classid = props.classid;
  //let classAssessments = props.assessmentInstanceID;
  let classAssessments = props.classAssessments;
  let gradeLevel = props.gradeLevel;
  let teachers = props.teachers;
  let teacherid = props.teacherid;
  let assessment = props.assessment;
  let gradeLevel1 = classDetails.grade_level1;
  let gradeLevel2 = classDetails.grade_level2;
  let trialClass = classDetails.trial_class;
  let nameOfClass = classDetails.name;
  let students = props.students;
  let studentsReadingScore = props.studentsReadingScore;
  let schoolid = props.schoolid;
  let additionalRoles = props.additionalRoles;
  let grade1Name = props.grade1Name || "";
  let grade2Name = props.grade2Name || "";

  console.log("studentsReadingScore:", studentsReadingScore);
  const [assessmentResultsByStudent, setAssessmentResultsByStudent] = useState(
    []
  );

  let [reportOptions, setReportOptions] = useState("");

  // Loading states
  const [isLoadingAssessmentResults, setIsLoadingAssessmentResults] = useState(false);
  const [isLoadingReportOptions, setIsLoadingReportOptions] = useState(false);

  const [showExpandedModal, setShowExpandedModal] = useState(false);
  const handleShowExpandedModal = () => setShowExpandedModal(true);
  const handleCloseExpandedModal = () => setShowExpandedModal(false);

  const [sortCriteria, setSortCriteria] = useState({
    field: null,
    order: null,
  });
  const [showAtRiskOnly, setShowAtRiskOnly] = useState(false);
  const [showSortedData, setShowSortedData] = useState(false);

  const handleShowSortedData = (data) => {
    setShowSortedData(data);
  };

  console.log(students, "students");

  console.log("showSortedData", showSortedData);

  useEffect(() => {
    if (assessment && assessment.instances) {
      setIsLoadingAssessmentResults(true);
      getResultsByStudent(assessment.instances)
        .then((response) => {
          setAssessmentResultsByStudent(response);
        })
        .catch((error) => {
          console.error("Error fetching assessment results:", error);
        })
        .finally(() => {
          setIsLoadingAssessmentResults(false);
        });
    }
  }, [assessment]);

  useEffect(() => {
    setIsLoadingReportOptions(true);
    getReportOptions(false)
      .then((response) => {
        setReportOptions(response);
      })
      .catch((error) => {
        console.error("Error fetching report options:", error);
      })
      .finally(() => {
        setIsLoadingReportOptions(false);
      });
  }, []);

  console.log(reportOptions);

  // Check if essential props are ready
  const isDataReady = classDetails && students && assessment && !isLoadingAssessmentResults && !isLoadingReportOptions;

  // Loading component
  const LoadingSpinner = () => (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
      <div className="text-center">
        <Spinner animation="border" role="status" variant="primary" style={{ width: "3rem", height: "3rem" }}>
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <div className="mt-3">
          <p className="text-muted">Loading class data and assessment results...</p>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Row className="inline-block align-items-center push-down mt-4">
        <Col className="col-auto">
          {/* <Suspense fallback={<div>Loading Navigation Button...</div>}>
            <ReturnToResults
              classDetails={classDetails}
              teachers={teachers}
              classAssessments={classAssessments}
              assessment={assessment}
              schoolid={schoolid}
              teacherid={teacherid}
            />
          </Suspense> */}
        </Col>
        <Col className="flex-grow-1 text-center" style={{ margin: "10px" }}>
          <h2 className="page-description-header-results">Reporting</h2>
        </Col>
        <Col className="col-auto d-flex justify-content-end">
          {isDataReady && (
            <PrintJiSiReports
              students={students}
              classDetails={classDetails}
              classid={classid}
              classAssessments={classAssessments}
              gradeLevel={gradeLevel}
              teachers={teachers}
              teacherid={teacherid}
              assessment={assessment}
              assessmentResultsByStudent={assessmentResultsByStudent}
              isPrintOut={false}
              sortCriteria={sortCriteria}
              showAtRiskOnly={showAtRiskOnly}
              setSortCriteria={setSortCriteria}
              setShowAtRiskOnly={setShowAtRiskOnly}
              studentsReadingScore={studentsReadingScore}
              showSortedData={showSortedData}
              onSortData={handleShowSortedData}
            />
          )}
        </Col>
        <Col className="col-auto"></Col>{" "}
        {/* Empty column to balance the layout */}
      </Row>
      <div className="class-overview-container">
        <Container className="container-shape">
          <Row className="page-description-bar">
            <Col className="col-6">
              <Row>
                <Col className="col-8">
                  <h2 className="page-description-header">
                    {nameOfClass || "Loading..."} {grade1Name} - {grade2Name} Observations
                  </h2>
                </Col>
              </Row>
              <p>Use edit buttons to add details for each student</p>
            </Col>
            <Col className="col-4">
              <Row>
                <Col className="col-3"></Col>
                <Col className="col-4"></Col>
                <Col className="col-1"></Col>
                <Col className="col-4"></Col>

                <Col className="col-6"></Col>
              </Row>
            </Col>
          </Row>
          <hr></hr>
          
          {!isDataReady ? (
            <LoadingSpinner />
          ) : (
            <>
              <Row>
                <Col className="d-flex justify-content-end">
                  <div
                    className="recommendations-button"
                    onClick={handleShowExpandedModal}
                  >
                    Expanded View
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      className="chevron-icon"
                    >
                      <path
                        d="M3.34188 9.5L3.342 9C3.28547 8.99999 3.22661 8.98207 3.17272 8.94314C3.11827 8.90381 3.0703 8.84368 3.04059 8.76616C3.01081 8.68845 3.00253 8.60099 3.01812 8.51626C3.03368 8.43164 3.07131 8.35879 3.12091 8.30515C3.12093 8.30513 3.12094 8.30511 3.12096 8.30509L5.85956 5.34508L6.17373 5.00552L5.85956 4.66596L3.12091 1.7059L3.12096 1.70585L3.11496 1.69958C3.08137 1.66452 3.05262 1.62047 3.03217 1.56901C3.0117 1.51752 3.00048 1.46088 3.00002 1.40269C2.99955 1.34449 3.00986 1.28756 3.02955 1.23552C3.04923 1.18353 3.07739 1.13873 3.1106 1.10284C3.14373 1.06703 3.18095 1.04103 3.21895 1.02422C3.25682 1.00748 3.29586 0.999652 3.33419 1.00001C3.37252 1.00037 3.41155 1.00893 3.44935 1.02648C3.48728 1.04409 3.52429 1.07095 3.55703 1.10758L3.55697 1.10763L3.56285 1.11398L6.88944 4.70951C6.95636 4.78187 7 4.88775 7 5.00552C7 5.12326 6.95639 5.22912 6.88949 5.30148C6.88947 5.3015 6.88945 5.30152 6.88944 5.30154L3.56285 8.89706L3.5628 8.89712C3.49708 8.96818 3.41662 8.99998 3.34177 9L3.34188 9.5ZM3.34188 9.5C3.17742 9.49996 3.01666 9.44722 2.87993 9.34845C2.74319 9.24967 2.63663 9.1093 2.57369 8.94507L3.92986 9.23662C3.77393 9.40521 3.56243 9.49995 3.34188 9.5Z"
                        fill="#1C64F2"
                        stroke="#1C64F2"
                      />
                    </svg>
                  </div>
                </Col>
              </Row>
              <Row className="button-container">
                <Col className="col-12">
                  <HandoverClassTable
                    getReport={getJiSiReportByStudentId}
                    upsertReport={upsertJiSiReport}
                    students={students}
                    classDetails={classDetails}
                    classAssessments={classAssessments}
                    gradeLevel={gradeLevel}
                    teachers={teachers}
                    teacherid={teacherid}
                    assessment={assessment}
                    assessmentResultsByStudent={assessmentResultsByStudent}
                    isPrintOut={false}
                    sortCriteria={sortCriteria}
                    showAtRiskOnly={showAtRiskOnly}
                    setSortCriteria={setSortCriteria}
                    setShowAtRiskOnly={setShowAtRiskOnly}
                    studentsReadingScore={studentsReadingScore}
                    setShowSortedData={setShowSortedData}
                    onSortData={handleShowSortedData}
                    additionalRoles={additionalRoles}
                  />
                  {/* <ReportClassTable /> */}
                </Col>
              </Row>
            </>
          )}

          <Modal
            show={showExpandedModal}
            onHide={handleCloseExpandedModal}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="custom-modal-width jisi-expandable-modal"
          >
            {" "}
            <Modal.Header closeButton>
              <Modal.Title>
                Expanded View of {grade1Name} to {grade2Name} Observations - {nameOfClass}
                {isDataReady && (
                  <PrintJiSiReports
                    students={students}
                    classDetails={classDetails}
                    classid={classid}
                    classAssessments={classAssessments}
                    gradeLevel={gradeLevel}
                    teachers={teachers}
                    teacherid={teacherid}
                    assessment={assessment}
                    assessmentResultsByStudent={assessmentResultsByStudent}
                    isPrintOut={false}
                    sortCriteria={sortCriteria}
                    showAtRiskOnly={showAtRiskOnly}
                    setSortCriteria={setSortCriteria}
                    setShowAtRiskOnly={setShowAtRiskOnly}
                    studentsReadingScore={studentsReadingScore}
                    showSortedData={showSortedData}
                    onSortData={handleShowSortedData}
                  />
                )}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {!isDataReady ? (
                <LoadingSpinner />
              ) : (
                <ExpandedHandoverView
                  key={showExpandedModal ? 1 : 0}
                  students={students}
                  classid={classid}
                  teachers={teachers}
                  showAtRiskOnly={showAtRiskOnly}
                  setShowAtRiskOnly={setShowAtRiskOnly}
                  studentsReadingScore={studentsReadingScore}
                  onSortData={handleShowSortedData}
                  showSortedData={showSortedData}
                  getReport={getJiSiReportByStudentId}
                />
              )}
            </Modal.Body>
            <Modal.Footer>
              <button
                className="blue-action-button"
                onClick={handleCloseExpandedModal}
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>

          <Row>
            <Col className="results-buttons"></Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default JiSiReportsOverview;
